import { render, staticRenderFns } from "./scenicNews.vue?vue&type=template&id=365b463c&scoped=true"
import script from "./scenicNews.vue?vue&type=script&lang=js"
export * from "./scenicNews.vue?vue&type=script&lang=js"
import style0 from "./scenicNews.vue?vue&type=style&index=0&id=365b463c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b463c",
  null
  
)

export default component.exports